import LeadTag from './LeadTag.component';

export default LeadTag;
